// ----------------------------------------------------------------------
// <copyright file="Izenda.UsersRoleSetupStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { observable, computed, action } from 'mobx';
import UiState from 'logic/Izenda.UiState';
import UsersRoleSetup from 'logic/models/Izenda.UsersRoleSetup';
import constant from 'logic/data/Izenda.UserAccountConstants';
import systemSettingFetcher from 'fetchers/Izenda.SystemSettingFetcher';
import { get, isEmpty } from 'lodash/fp';

/**
 * The store handles UI and logic of Users of a Role Setup
 */
export default class UsersRoleSetupStore {
  model: UsersRoleSetup;
  lazyLoadingStore: any;

  @observable configUser: any = null;

  @observable alertMessage: any = {};

  @computed
  get tenantId() {
    return UiState.getTenantId();
  }

  @computed
  get isDirty() {
    return this.configUser.isDirty;
  }

  constructor(selectedUser: any) {
    this.model = new UsersRoleSetup(selectedUser);
  }

  /**
  * reset alert message
  */
  @action
  resetAlertMessage() {
    this.alertMessage = {};
  }

  /**
   * Register LazyLoading Store
   * @param  {Object} store
   */
  registerLazyLoadingStore(store: any) {
    this.lazyLoadingStore = store;
  }

  /**
   * Load partial user list by lazy loading
   * @return {promise}
   */
  @action
  getPartialUsers(pageInfo: any, isSearching: any, searchText = null) {
    pageInfo = pageInfo || this.lazyLoadingStore.pageInfoForFirstTime;

    const params = {
      tenantId: this.tenantId,
      skipItems: pageInfo.fromIndex,
      pageSize: pageInfo.pageSize,
      criteria: [
        {
          key: constant.USER_LIST_SEARCH_KEY,
          value: searchText
        }
      ]
    };

    const parseUsers = result => {
      const filterText = get('searchedUserName', this.model);
      if (searchText === filterText || isEmpty(searchText) === isEmpty(filterText)) {
        this.model.populateLazyUserList(result, isSearching);
      }
    };

    return systemSettingFetcher.getPartialUsers(params).then(parseUsers);
  }

  /**
   * Search users by search text
   * @param {String} searchText 
   */
  @action
  searchUsers(searchText: string) {
    this.model.updateSearchedUserName(searchText);

    this.getPartialUsers(null, true, searchText);
  }
}



// WEBPACK FOOTER //
// ./ui/logic/Izenda.UsersRoleSetupStore.js